import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { confirmPasswordValidator } from '@app/shared/validators/confirmPassword.validator';
import { passwordRegexValidator } from '@app/shared/validators/password.validator';

@Component({
    selector: 'change-password-form',
    templateUrl: './change-password-form.component.html',
    styleUrls: ['./change-password-form.component.scss'],
    standalone: false
})
export class ChangePasswordFormComponent {

  public updatePasswordForm = this.fb.group({
    password: ['', [Validators.required, passwordRegexValidator()]],
    confirmPassword: [null, {
      validators: [Validators.required, confirmPasswordValidator('password')],
      updateOn: 'change'
    }]
  });


  constructor(
    private dialog: DynamicDialogRef,
    public translate: TranslateService,
    private config: DynamicDialogConfig,
    private fb: FormBuilder) {
    this.updatePasswordForm.reset(this.config.data);
  }

  public onSaveClick(event: Event) {
    event.preventDefault();

    if (!this.updatePasswordForm.invalid) {
      this.dialog.close({
        action: true,
        data: {
          user: this.config.data.user,
          password: this.updatePasswordForm.value.password,
          confirmPassword: this.updatePasswordForm.value.confirmPassword
        }
      });
    }
  }
}
